import React, { useCallback, useEffect, useState } from "react";
import { Col, Row, Typography, Spin, message } from "antd";
import Button from "../../../Button";
import { formatCurrency } from "../../../../utils";
import api from "../../../../services/api";
import { useClients } from "../../../../contexts/ClientsContext";
import { useAuth } from "../../../../contexts/AuthContext";
import { CopyText } from "./components/CopyText";
import { getPlanPrice, planos } from "../../../Planos/planos";
import { Plan as IPlan, UserPlan, UserPlanEnum } from "../../../../constants/plans";

var getStatus: NodeJS.Timeout;

interface PixStepProps {
  paymentData: any;
  handleIdBack?: (event: any) => void;
  onSucess?: (event: any) => void;
  backStep?: () => void;
  clientUsername: any,
  type: any,
  setStep: any,
  onCancel: any,
  plan?: IPlan | UserPlan;
  filters?: any
}

enum EPlanStep {
  CHOOSE_PAYMENT = "CHOOSE_PAYMENT",
  PIX_PAYMENT = "PIX_PAYMENT",
  CC_PAYMENT = "CC_PAYMENT",
  PAYMENT_LINK= "PAYMENT_LINK",
  LOADING = "LOADING",
  FINISHED = "FINISHED",
}

const pixTaxesByInsitution: Record<string, number> = {
  "imoveis-velotax": 350,
  "rendimentos-velotax": 9.9,
  "bolsa-velotax": 9.9,
  "exterior-velotax": 9.9,
  "crypto-velotax": 9.9,
};

export const PixStep: React.FC<PixStepProps> = ({
  paymentData,
  handleIdBack,
  onSucess,
  backStep,
  clientUsername,
  type,
  setStep,
  onCancel,
  plan,
  filters
}) => {
  const { selectedClient, getClients, setSelectedClient } = useClients();
  const [loading, setLoading] = useState(false);
  const [brCode, setBrCode] = useState<string>('');
  const [qrCode, setQrCode] = useState<string>('');
  const provider = paymentData.isPlan ? "pagarme" : "starkbank";
  const { user } = useAuth();

  useEffect(() => {
    if (provider === "pagarme") {
      createPlanXPPro();
    }
    // eslint-disable-next-line
  }, []);

  const checkWasPaid = useCallback(
    (delay: number = 5) => {
      let attempts = 0;
      getStatus = setInterval(async () => {
        api
          .post(`/plans/checkWasPaidPix`, {username: clientUsername})
          .then(async (res) => {
            if (res.data?.payed) {
              clearInterval(getStatus);
              message.success("Pagamento Confirmado com sucesso!")
              setStep(EPlanStep.FINISHED);
              const { clients } = await getClients({...(filters || {})});
              const client = selectedClient;
              const newClient = clients.find((c: any) => c.username === client?.username);
              setSelectedClient(null);
              setTimeout(() => {
                setSelectedClient(newClient);
              }, 300);
            }
          })
          .finally(() => {
            attempts += 1;
            if (attempts > 100) {
              clearInterval(getStatus);
            }
          });
      }, delay * 1000);
    },
    []
  );

  useEffect(() => {
    // return () => getStatus && clearInterval(getStatus);
  }, [checkWasPaid]);

  const createPlanXPPro = () => {
    const body = {
      clientUsername,
      type,
      from: "VELOPRIME",
      planUpgrade: paymentData.planUpgrade || false,
      isPlan: true,
      acceptTerms: true,
      clientInfo: {
        name: user.user.name,
        email: user.user.email,
        document: user.user.username,
        isAssessor: true
      },
      paymentForm: 'pix',
    };
    setLoading(true);
    api
      .post("/plans/createPayment", body)
      .then(async (res) => {
        if (res.data.br_code && res.data.qrCode) {
          setBrCode(res.data.br_code)
          setQrCode(res.data.qrCode)
          checkWasPaid()
        } else {
          message.info(
            "Seu pagamento ainda não foi processado. Tente novamente mais tarde."
          );
          setStep(EPlanStep.CHOOSE_PAYMENT);
          if (onCancel) onCancel();
        }
      })
      .catch(() => {
        message.error("Algo deu errado. Tente novamente mais tarde.");
        setStep(EPlanStep.CHOOSE_PAYMENT);
        paymentData.stopIntervalPix()
      })
      .finally(async () => {
        setLoading(false)
      });
  };

  const getDiscount = () => {
    if (paymentData.type === UserPlanEnum.VELOTAX_MAIN_PRO) {
      if (user?.user?.discount! >= 33) return 33.38898164;
      else return user?.user?.discount || 0;
    }
    if (paymentData.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) {
      if (user?.user?.discount! >= 50) return 50.06257822;
      return user?.user?.discount || 0;
    }
    else return user?.user?.discount || 0
  }

  const plano = planos.find(p => p.type === paymentData.type)
  const price = getPlanPrice(plano!, false) ?? 25.9;
  const installments = plano?.installments || 1;
  let totalPrice = price * installments;
  if (user.user.discount && paymentData.type !== UserPlanEnum.VELOTAX_MAIN_BASIC) 
    totalPrice -= totalPrice * (getDiscount() / 100);
  const planPrice = totalPrice / installments;

  return (
    <Row>
      <Col>
        <Row
          gutter={[16, 16]}
        >
          <Col>
            <Typography style={{ color: "var(--velotax-font-color-dark)" }}>
              Abra o aplicativo do banco em que você possui o PIX cadastrado e
              selecione a opção de escanear QR Code ou PIX copia e cola.{" "}
              {paymentData.isPlan && (
                <Col
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "16px 0",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography.Text
                    strong
                    style={{
                      textAlign: "center",
                      color: "var(--velotax-font-color-dark)",
                    }}
                  >
                    Plano anual
                  </Typography.Text>
                  <Typography.Text
                    style={{
                      textAlign: "center",
                      color: "var(--velotax-font-color-dark)",
                    }}
                  >
                    12x de {formatCurrency(planPrice)} ={" "}
                    {formatCurrency(planPrice * 12)}
                  </Typography.Text>
                </Col>
              )}
            </Typography>
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "16px",
              width: "100%",
              // marginTop: -35,
            }}
          >
            {!qrCode && !qrCode && (
              <Spin spinning={loading} style={{ margin: "32px" }}></Spin>
            )}

            {qrCode && (
              <img
                alt="PIX QRCode"
                style={{ width: 190 }}
                src={qrCode}
              />
            )}
          </Col>
        </Row>
        <Row gutter={[16, 16]} justify="center">
          {brCode ? (
            <>
              <Col span={24}>
                <Typography.Paragraph
                  style={{
                    textAlign: "center",
                    wordBreak: "break-all",
                    fontWeight: 500,
                    fontSize: "11px",
                    maxWidth: "240px",
                    margin: "0 auto",
                    color: "var(--velotax-font-color-dark)",
                  }}
                >
                  <CopyText id="pix-code">{brCode}</CopyText>
                </Typography.Paragraph>
              </Col>
            </>
          ) : (
            ""
          )}
        </Row>
        {!paymentData.isPlan && (
          <Row style={{ marginTop: "5px" }}>
            <Col>
              <Typography.Paragraph style={{ textAlign: "left", fontSize: 12 }}>
                Taxa de serviço:{" "}
                {formatCurrency(
                  pixTaxesByInsitution?.[paymentData.institution] || 9.9
                )}
              </Typography.Paragraph>
            </Col>
          </Row>
        )}
        <Button
          size="middle"
          type="default"
          onClick={() => backStep && backStep()}
        >
          <span className="xp-link uppercase">Voltar</span>
        </Button>
      </Col>
    </Row>
  );
};
